import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { modal } from 'redux/modules/app'
import { AssessorReport } from 'containers/forms/assessor'
import {
  AssessorParticipantActivity,
  AssessorParticipantTable,
  AssessorParticipantLogs,
  AssessorParticipantInfo,
  AssessorParticipantActivities
} from 'components/sections/assessor'
import { AuthCodeInvalid } from 'components/misc'
import { HeaderPlain, NarrowContainer } from 'components/layout'
import { apiActivities, apiCodeLists, apiConfiguration } from 'helpers/decorators/api'
import { meta } from 'helpers/decorators'
import { CONFIGURATION_KEYS } from '../../../constants/enums'


@meta({
  title: 'Assessor assessment'
})
@connect(
    state => ({
      activityDetail: state.api.activities.detail
    }),{ modal })
@apiCodeLists(['titles'], { public: true })
@apiConfiguration()
@apiActivities({
  publicDetail: true,
  publicActivityLogs: true
})
class AssessorActivityAssessment extends Component {
  static propTypes = {
    modal: PropTypes.func.isRequired,
    activities: PropTypes.object.isRequired,
    approveActivityAssessorReport: PropTypes.func.isRequired,
    rejectActivityAssessorReport: PropTypes.func.isRequired,
    getPublicActivityAssessmentRequests: PropTypes.func.isRequired,
    codeLists: PropTypes.object.isRequired,
    configuration: PropTypes.object.isRequired,
    activityDetail: PropTypes.object.isRequired,
    onGetConfigurationValue: PropTypes.func.isRequired
  }

  state = {
    loaded: false,
    error: null
  }

  componentDidMount() {
    const { activities } = this.props

    this.handleActivityAssessment(
        get(activities, 'detail.id'),
        get(activities, 'detail.activityAssessmentRequestActionId')
    )
  }

  componentWillReceiveProps(nextProps) {
    const { activities,activityDetail } = this.props

    if (
        !get(activities, 'error.userMessage') &&
        get(nextProps.activities, 'error.userMessage')
    ) {
      this.setState({
        error: get(nextProps.activities, 'error.userMessage')
      })
    }

    if (
        get(activities, 'detail.activityAssessmentRequestActionId') !==
        get(nextProps.activities, 'detail.activityAssessmentRequestActionId')
    ) {
      this.handleActivityAssessment(
          get(nextProps.activities, 'detail.id'),
          get(nextProps.activities, 'detail.activityAssessmentRequestActionId')
      )
    }

    if (
        get(activityDetail, 'award.organization.id') !==
        get(nextProps.activityDetail, 'award.organization.id')
    ) {
      const orgId = get(nextProps.activityDetail, 'award.organization.id')

      orgId && this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isAssessorReportAdditionalInfoEnabled.id, orgId)
      orgId && this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isPersonalReflectionFroActivityEnabled.id, orgId)
    }
  }

  handleActivityAssessment = (activityId, actionId) => {
    actionId &&
    this.props.getPublicActivityAssessmentRequests(activityId, actionId)
  }

  render() {
    const {
      activities,
      codeLists,
      approveActivityAssessorReport,
      rejectActivityAssessorReport,
      configuration,
      activityDetail
    } = this.props
    const { error } = this.state

    const orgId = get(activityDetail, 'award.organization.id')

    const isAssessorReportAdditionalInfoEnabled = get(configuration, `valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.isAssessorReportAdditionalInfoEnabled.id}].booleanValue`)

    const isPersonalReflectionFroActivityEnabled = get(configuration, `valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.isPersonalReflectionFroActivityEnabled.id}].booleanValue`)

    return (
        <div>
          <HeaderPlain />
          <NarrowContainer>
            {error && <AuthCodeInvalid />}
            {activities.loaded && (
                <div className="content">
                  <AssessorParticipantInfo activity={activities.detail}>
                    <AssessorParticipantTable activity={activities.detail} />
                  </AssessorParticipantInfo>

                  <AssessorParticipantActivity
                      activity={activities.detail}
                      assessment={activities.assessment}
                      isPersonalReflectionFroActivityEnabled={isPersonalReflectionFroActivityEnabled}
                  />

                  <AssessorParticipantActivities activity={activities.detail} />

                  <AssessorParticipantLogs logs={activities.logs.list} />

                  <AssessorReport
                      data={activities.detail}
                      assessment={activities.assessment}
                      sending={activities.sending}
                      sent={activities.reportSent}
                      onSubmit={approveActivityAssessorReport}
                      onReject={rejectActivityAssessorReport}
                      codeLists={codeLists}
                      modal={this.props.modal}
                      isAssessorReportAdditionalInfoEnabled={isAssessorReportAdditionalInfoEnabled}

                  />
                </div>
            )}
          </NarrowContainer>
        </div>
    )
  }
}

export default AssessorActivityAssessment
